// src/data/weeklyChallenge.js
import { WEEKLY_UNIT, WEEKLY_QUIZ, WEEKLY_QUIZ_SET, THIRD_CONDITIONAL_UNIT } from './weeklyQuiz.js';

// Sets individuales genéricos para cada mini reto del desafío semanal
export const WEEKLY_SET_1 = WEEKLY_UNIT?.sets?.[0] ? {
  ...WEEKLY_UNIT.sets[0],
  id: 'weekly-set-1',
  returnView: 'weekly-challenge'
} : null;

export const WEEKLY_SET_2 = WEEKLY_UNIT?.sets?.[1] ? {
  ...WEEKLY_UNIT.sets[1],
  id: 'weekly-set-2',
  returnView: 'weekly-challenge'
} : null;

export const WEEKLY_SET_3 = WEEKLY_UNIT?.sets?.[2] ? {
  ...WEEKLY_UNIT.sets[2],
  id: 'weekly-set-3',
  returnView: 'weekly-challenge'
} : null;

export const WEEKLY_SET_4 = WEEKLY_UNIT?.sets?.[3] ? {
  ...WEEKLY_UNIT.sets[3],
  id: 'weekly-set-4',
  returnView: 'weekly-challenge'
} : null;

// Aliases para compatibilidad con código anterior
export const WEEKLY_TRAVEL_SET = WEEKLY_SET_1;
export const WEEKLY_NATURE_SET = WEEKLY_SET_2;
export const WEEKLY_REGRETS_SET = WEEKLY_SET_3;

const DEFAULT_ICONS = ['📘', '🧠', '✨', '🏁', '🎯', '📝'];

/**
 * Estructura dinámica y genérica del Desafío Semanal.
 * Se adapta automáticamente a cualquier unidad y número de sets definidos en weeklyQuiz.js
 * sin necesidad de reconectar ni renombrar constantes cada semana.
 */
export const WEEKLY_CHALLENGE = {
  id: WEEKLY_QUIZ.id || 'weekly-challenge-current',
  title: WEEKLY_QUIZ.title || 'Desafío Semanal',
  subtitle: WEEKLY_UNIT.title || 'Desafío de la Semana',
  description: WEEKLY_QUIZ.description || 'Supera los mini retos de la semana para dominar el tema.',
  totalQuestions: WEEKLY_QUIZ.totalQuestions || 30,
  estimatedMinutes: WEEKLY_QUIZ.estimatedMinutes || 12,
  xpReward: 350,
  isActive: WEEKLY_QUIZ.isActive !== undefined ? WEEKLY_QUIZ.isActive : true,
  sections: (WEEKLY_UNIT.sets || []).map((set, idx) => {
    const rawTitle = set.title || `Mini Reto ${idx + 1}`;
    const cleanTitle = rawTitle.replace(/^Set \d+:\s*/i, '').split('(')[0].trim() || `Parte ${idx + 1}`;
    const cleanSubtitle = rawTitle.includes('(')
      ? rawTitle.split('(')[1].replace(')', '').trim()
      : `Mini reto ${idx + 1}`;

    return {
      id: `weekly-section-${idx + 1}`,
      title: cleanTitle,
      subtitle: cleanSubtitle,
      icon: DEFAULT_ICONS[idx] || '📝',
      estimatedMinutes: Math.max(2, Math.round((WEEKLY_QUIZ.estimatedMinutes || 12) / (WEEKLY_UNIT.sets.length || 1))),
      totalQuestions: set.questions?.length || 10,
      set: {
        ...set,
        id: `weekly-set-${idx + 1}`,
        returnView: 'weekly-challenge'
      }
    };
  })
};

// Aliases genéricos para máxima compatibilidad si se cruzan importaciones
export { WEEKLY_QUIZ, WEEKLY_QUIZ_SET, WEEKLY_UNIT, THIRD_CONDITIONAL_UNIT };
